import {Box, CardHeader, CardMedia, Typography, IconButton, Avatar} from "@mui/material";
import {OriginalCalendarButton} from "../Button/OriginalCalendarButton.jsx";
import Grid from "@mui/material/Grid";
import CardContent from "@mui/material/CardContent";
import Card from "@mui/material/Card";
import Button from "@mui/material/Button";
import DayCalendar from "../DayCalendar.jsx";
import {Crumbs} from "../Crumbs.jsx";
import {InTownURI} from "../Button/InTownButton.jsx";
import {OutOfTownURI} from "../Button/OutOfTownButton.jsx";
import {today} from "../../shared/date.js";
import {useEffect, useState} from "react";
import {DailyCalendarButton} from "../Button/DailyCalendarButton.jsx";
import {Helmet} from "react-helmet";
import {LatestAnnouncement} from "./Announcement.jsx";
import {useEvents} from "../DanceEventProvider.jsx";
import {EventCardCompact} from "../EventCardCompact.jsx";
import {ThemeProvider, createTheme} from "@mui/material/styles";

const lightTheme = createTheme({ palette: { mode: "light" } });

const title = "Austin 2-Step welcomes you. Let's dance!"
const desc = "Everything you need to know about where, when and how to dance 2-step in Austin, TX"

const WhatsGood = () => {
    const { events } = useEvents();

    const specialEvents = events.filter(e => e.special === true);
    const popularEvents = events.filter(e => e.popular === true);

    if (specialEvents.length === 0 && popularEvents.length === 0) return null;

    return <ThemeProvider theme={lightTheme}>
        <Box sx={{ width: "100%", bgcolor: "background.paper", color: "text.primary", p: 2, borderRadius: 1 }}>
        <Typography variant="h5" sx={{ mb: 1 }}>What's good tonight?</Typography>
        {specialEvents.length > 0 && (
            <Box sx={{ mb: 2 }}>
                <Grid container spacing={1}>
                    {specialEvents.map((event, i) => (
                        <Grid item xs={12} md={6} key={event.documentId || event.id || i}>
                            <EventCardCompact event={event} />
                        </Grid>
                    ))}
                </Grid>
            </Box>
        )}
        {popularEvents.length > 0 && (
            <Box sx={{ mb: 2 }}>
                <Grid container spacing={1}>
                    {popularEvents.map((event, i) => (
                        <Grid item xs={12} md={6} key={event.documentId || event.id || i}>
                            <EventCardCompact event={event} />
                        </Grid>
                    ))}
                </Grid>
            </Box>
        )}
        </Box>
    </ThemeProvider>
}

const TodayPage = () => {
    const [todayStr, setToday] = useState(today())

    useEffect(() => {
        //ensure this calendar advances after 2am (today() waits till 2am)
        const intervalId = setInterval(() => {
            if (todayStr < today()) {
                setToday(today())
            }
        }, 60000)
        return () => clearInterval(intervalId)
    })

    return <Grid container spacing={1}>
        <Grid item xs={12} md={4}>
            
            <Box align="center">
                <a href="/where-to-dance">
                    <img src="/images/honky-tonks.gif" alt="Honky Tonks" style={{ width: "150px", height: "auto" }}/>
                </a>
            </Box>
        </Grid>
        <Grid item xs={12} md={4}>
            <Box align="center">
                <a href="/boot-guide">
                    <img src="/images/boot-guide.gif" alt="Boot Guide" style={{ width: "150px", height: "auto" }}/>
                </a>
            </Box>
        </Grid>
        <Grid item xs={12} md={4}>
            <Box align="center">
                <a href="/where-to-dance/pro-calendar">
                    <img src="/images/pro-calendar.gif" alt="Pro Calendar" style={{ width: "150px", height: "auto" }}/>
                </a>
            </Box>
        </Grid>
        
        <Grid item xs={12}>
            <Helmet>
                <meta charSet="utf-8"/>
                <meta property="og:description" content={desc}/>
                <meta property="og:title" content={title}/>
                <meta property="twitter:title" content={title}/>
                <meta property="twitter:description" content={desc}/>
                <title>{title}</title>
                <meta property="description" content={desc} />
                <link rel="canonical" href="https://austin2step.com/twostep-lessons"/>
            </Helmet>
        </Grid>
        <Grid item xs={12}>
            <LatestAnnouncement />
        </Grid>
        {/* <Grid item xs={12}>
            <WhatsGood />
        </Grid> */}
        {/* <Grid item xs={12} style={{textAlign: "center"}}>
            <a 
                href="/holiday-guide"
            >
                <img src="/holiday-guide-icon.png" alt="Holiday Guide" width={350}/>
            </a>
        </Grid> */}
        <Grid item xs={12}>
            <DayCalendar date={todayStr}/>
        </Grid>
        <Grid item xs={12} md={6}>
            <Card>
                <CardHeader
                    title={"Where To Dance"}
                    subheader={"In Austin and abroad"}

                />
                <CardMedia
                    component="img"
                    image={"/images/hair-spin.jpeg"}
                    height={150}
                />
                <CardContent>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={6} style={{textAlign: "center"}}>
                            <Box mt={2} style={{display: "flex", flexDirection: "column", alignItems: "center", spacing: 1, gap: 8}}>
                                <DailyCalendarButton fullWidth/>
                                <Box><Typography variant={"body2"}>View by Day, Detailed</Typography></Box>
                            </Box>
                        </Grid>
                        <Grid item xs={12} md={6} style={{textAlign: "center"}}>
                            <Box mt={2} style={{display: "flex", flexDirection: "column", alignItems: "center", spacing: 1, gap: 8}}>
                                <OriginalCalendarButton fullWidth />
                                <Box><Typography variant={"body2"}>6 weeks, simplified</Typography></Box>
                            </Box>
                        </Grid>
                        <Grid item xs={12} style={{textAlign: "center"}}>
                            <Typography variant={"overline"}>Places</Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Box style={{display: "flex", flexDirection: "column", justifyContent: "space-around", spacing: 1, gap: 8}}>
                                <Button fullWidth variant={"outlined"} href={"/where-to-dance"}><span style={{fontSize: "80%"}}>Favorite Spots</span></Button>
                                <Button fullWidth variant={"outlined"} href={InTownURI}><span style={{fontSize: "80%"}}>In & Near Austin</span></Button>
                                <Button fullWidth variant={"outlined"} href={OutOfTownURI}><span style={{fontSize: "80%"}}>Outside of Austin</span></Button>
                            </Box>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
    </Grid>
    <Grid item xs={12} md={6}>
            <Card style={{height: "100%"}}>
                <CardHeader
                    title={"Learn more about 2-Steppin"}
                    subheader={"Lessons and Culture"}

                />
                <CardMedia
                    component="img"
                    image={"/images/lessons.jpeg"}
                    height={250}
                />
                <CardContent>
                    <Box>
                        {/*<Typography variant={"body2"}>If wanna learn more about how to 2-step, or just more abou the culture, we have you covered!</Typography>*/}
                        <Box mt={1}>
                            <Button href={"/twostep-lessons"}>2-Step Lessons</Button>
                            <Typography variant={"body2"}>All of the places for drop-in 2-step lesson organized by day.</Typography>
                        </Box>
                        <Box mt={4}>
                            <Button href={"/quick-start-austin-2-step-guide"}>Culture Guide</Button>
                            <Typography variant={"body2"}>Learn more about the in's and out's of Austin's honky tonk culture.</Typography>
                        </Box>
                    </Box>

                </CardContent>
            </Card>
        </Grid>
    </Grid>
}

export default TodayPage